module.exports = __webpack_public_path__ + "3932bfeba322f4dd5ebe4f90826643f5.png";